import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import CarClassWriteDTO from '../../../../../../types/car-class/CarClassWriteDTO';
import { CarClassService } from '../../../../services/car-class.service';

@Component({
    selector: 'app-update-car-class-dialog',
    templateUrl: './update-car-class-dialog.component.html',
    styleUrls: [ './update-car-class-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
    ]
})
export class UpdateCarClassDialogComponent {
    @Input() visible: boolean = false;
    @Input() carClass: CarClassWriteDTO = new CarClassWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() carClassUpdated: EventEmitter<CarClassWriteDTO> = new EventEmitter<CarClassWriteDTO>();

    constructor(private carClassService: CarClassService,
                private messageService: MessageService) {
    }

    public loading = false;

    get saveDisabled(): boolean {
        return !this.carClass?.name || !this.carClass?.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateCarClass() {
        this.loading = true;

        this.carClassService.updateCarClass(this.carClass).then(() => {
            this.carClassUpdated.emit(this.carClass);
            this.close();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }
}
